/**
 * 文本
 * @author yuxin.zhang 2018.11.9
 */

import React from 'react';

import { FormType } from '../FormType';

import ItemContext from './ItemContext';
import LeftTitle from './LeftTitle';

export default class ItemTextArea extends ItemContext {
  constructor(props) {
    super(props);

    this.state = {
      errorMsg: '',
      dataError: false,
      value: '',
    };
  }

  UNSAFE_componentWillMount() {
    this.setValue(this.props.dataSource);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setValue(nextProps.dataSource);
    this.setError(nextProps.dataSource);
    this.cleanError(nextProps.dataSource);
  }

  /**
   * 输入值变化监听
   * @param e
   */
  onChange = (e) => {
    const { key, onChange, errorData, formType, extend, filter } =
      this.props.dataSource;
    const val = filter ? filter(e.target.value) : e.target.value;

    const errorMsg = this.getErrorMsg(val, errorData);
    const allow = errorMsg.length === 0;
    this.setState({
      value: val,
      errorMsg,
    });
    onChange && onChange(key, formType, val, allow, extend);
  };

  /**
   * 渲染文本类型
   * @returns {*}
   */
  renderFormLineTextArea() {
    const { errorMsg, value } = this.state;
    const { inputAttr, bottomArea } = this.props.dataSource;
    return (
      <div className="form-input-box">
        <textarea
          {...inputAttr}
          value={value}
          className="input form-text-area"
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
        />
        <br />
        {bottomArea}
        <span className="form-error-tips">{errorMsg}</span>
      </div>
    );
  }

  render() {
    const { dataError, errorMsg } = this.state;
    const { dataSource } = this.props;
    return (
      <div
        className="form-item"
        data-error={dataError && errorMsg && errorMsg.length !== 0}
      >
        <LeftTitle dataSource={dataSource} />
        {this.renderFormLineTextArea()}
        {dataSource.rightArea}
      </div>
    );
  }
}

ItemTextArea.defaultProps = {
  dataSource: {
    key: '',
    extend: null,
    placeholderRight: null,
    formType: FormType.TEXT_AREA,
    inputAttr: {},
    defaultValue: '',
    errorData: [],
    callback: null,
    onChange: null,
    onBlur: null,
    filter: (val) => {
      return val;
    },
  },
};
